import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL
const API_MAIN = `${API_URL}/api/v1`
export const getListTimeKeeping = (
  page: number,
  rowOfPage: number,
  data: {
    keyword?: string
    startDate: string
    endDate: string
  }
) => {
  let url = `${API_MAIN}/timekeepings/page?pageIndex=${page}&pageSize=${rowOfPage}&startDate=${data.startDate}&endDate=${data.endDate}`
  if (data.keyword) {
    url += `&keyword=${data.keyword}`
  }
  return axios.get(url)
}
export const exportToExcel = (
  startDate: string,
  endDate: string,
  page: number,
  rowOfPage: number
) => {
  const url = `${API_MAIN}/timekeepings/export-excel?pageIndex=${page}&pageSize=${rowOfPage}&startDate=${startDate}&endDate=${endDate}`
  return axios.get(url, {
    responseType: 'blob',
  })
}
